/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, mixins } from '@blend/consumer-components';

export namespace Card {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {}
}

const styles = StyleSheet.create({
  card: {
    ...mixins.globalBorderStyle,
    ...mixins.padding(25),
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    color: colors.clayPlus3,
  },
});

export const Card: React.FC<Card.Props> = ({ children, ...htmlProps }) => {
  return (
    <div className={css(styles.card)} {...htmlProps}>
      {children}
    </div>
  );
};
